import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "c-pagination",
  "aria-label": "Page navigation example"
}
const _hoisted_2 = { class: "inline-flex items-center -space-x-px" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Anterior", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = ["onClick", "disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Próximo", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickPreviousPage && _ctx.onClickPreviousPage(...args))),
          disabled: _ctx.isInFirstPage,
          class: "block p-3 ml-0 mr-1 leading-tight text-text-light rounded-full hover:bg-primary-base hover:text-white"
        }, _hoisted_6, 8, _hoisted_3)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "w-11 h-11",
          key: page.name
        }, [
          _createElementVNode("button", {
            type: "button",
            onClick: ($event: any) => (_ctx.onClickPage(page.name)),
            disabled: page.isDisabled,
            class: _normalizeClass([
            _ctx.isPageActive(page.name)
              ? 'text-white bg-primary-base'
              : 'text-text-light'
          , "font-regular border border-transparent w-full h-full leading-tight block rounded-full hover:bg-primary-base hover:text-white"])
          }, _toDisplayString(page.name + 1), 11, _hoisted_7)
        ]))
      }), 128)),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickNextPage && _ctx.onClickNextPage(...args))),
          disabled: _ctx.isInLastPage,
          class: "block p-3 leading-tight text-text-light rounded-full hover:bg-primary-base hover:text-white"
        }, _hoisted_11, 8, _hoisted_8)
      ])
    ])
  ]))
}